"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullPalette = exports.FOCUS_BORDER_COLOR = void 0;
var FullPalette = exports.FullPalette = {
  // GREEN
  GREEN_E25: '#F3FFFB',
  GREEN_E50: '#E6FFF8',
  GREEN_E100: '#C9F0E6',
  GREEN_E200: '#ADE1D4',
  GREEN_E300: '#90D1C2',
  GREEN_E400: '#73C2B0',
  GREEN_500: '#4CB398',
  GREEN_600: '#24A47F',
  GREEN_700: '#047957',
  // POPPY
  POPPY_E25: '#FFF7F8',
  POPPY_E50: '#FFE5E3',
  POPPY_E100: '#F9C9C5',
  POPPY_E200: '#F3ACA7',
  POPPY_E300: '#EE9089',
  POPPY_E400: '#E8736B',
  POPPY_500: '#E3564B',
  POPPY_600: '#D8372A',
  POPPY_700: '#B52617',
  // ZINNIA
  ZINNIA_E25: '#FFE4D7',
  ZINNIA_E50: '#FFD9C7',
  ZINNIA_E100: '#FFC6AC',
  ZINNIA_E200: '#FFB490',
  ZINNIA_E300: '#FFA274',
  ZINNIA_E400: '#FF8F59',
  ZINNIA_500: '#FF7B39',
  ZINNIA_600: '#FF6519',
  ZINNIA_700: '#D44A00',
  // MARIGOLD
  MARIGOLD_E25: '#FFF6EB',
  MARIGOLD_E50: '#FFECD4',
  MARIGOLD_E100: '#FFE3BE',
  MARIGOLD_E200: '#FFDAA9',
  MARIGOLD_E300: '#FFD093',
  MARIGOLD_E400: '#FFC77D',
  MARIGOLD_500: '#FFB756',
  MARIGOLD_600: '#FFA52E',
  MARIGOLD_700: '#FF8500',
  // YELLOW
  YELLOW_E25: '#FFFBD7',
  // NO YELLOW_E50
  // NO YELLOW_E100
  // NO YELLOW_E200
  // NO YELLOW_E300
  // NO YELLOW_E400
  YELLOW_500: '#FFF9C1',
  YELLOW_600: '#FFE607',
  YELLOW_700: '#F2CD00',
  // IRIS
  IRIS_E25: '#ECF3FF',
  IRIS_E50: '#D6E6FF',
  IRIS_E100: '#BFD5F8',
  IRIS_E200: '#A7C4F1',
  IRIS_E300: '#90B4EA',
  IRIS_E400: '#78A3E3',
  IRIS_500: '#578BDD',
  IRIS_600: '#3574D6',
  IRIS_700: '#054AB2',
  // VIOLET
  VIOLET_E25: '#F2EBFB',
  VIOLET_E50: '#D6C5EB',
  VIOLET_E100: '#C8B2E4',
  VIOLET_E200: '#BA9FDE',
  VIOLET_E300: '#AC8BD7',
  VIOLET_E400: '#9E78D0',
  VIOLET_500: '#9165C9',
  VIOLET_600: '#753EBC',
  VIOLET_700: '#462571',
  // EVERGREEN
  EVERGREEN_E25: '#DDE5E2',
  EVERGREEN_E50: '#BBCCC6',
  EVERGREEN_E100: '#A1B4AD',
  EVERGREEN_E200: '#879C95',
  EVERGREEN_E300: '#6C837C',
  EVERGREEN_E400: '#526B63',
  // NO EVERGREEN_E500
  EVERGREEN_600: '#335247',
  EVERGREEN_700: '#15372C',
  // GREY
  GREY_E25: '#F9FAF9',
  // NO GREY_E50
  // NO GREY_E100
  // NO GREY_E200
  // NO GREY_E300
  // NO GREY_E400
  GREY_E500: '#EFF1F0',
  GREY_600: '#E0E5E3',
  GREY_700: '#CCD4D1',
  GREY_800: '#677D76',
  GREY_900: '#526B63',
  WHITE: '#FFFFFF'
};
var FOCUS_BORDER_COLOR = exports.FOCUS_BORDER_COLOR = 'rgb(0, 95, 204)';